import { staffSessionSchema } from "@lafayette/schemas";
import { createMemoryTransport, } from "./memory-transport";
export function createStaffSessionApi(options) {
    const send = createMemoryTransport(options);
    return {
        get: (callOptions) => send({
            method: "GET",
            path: "/staff/session",
            schema: staffSessionSchema,
            maxNetworkRetries: 0,
            signal: callOptions?.signal,
        }),
    };
}
